import { render, staticRenderFns } from "./modal-order-help.vue?vue&type=template&id=1b28c4ff&scoped=true&"
import script from "./modal-order-help.vue?vue&type=script&lang=js&"
export * from "./modal-order-help.vue?vue&type=script&lang=js&"
import style0 from "./modal-order-help.vue?vue&type=style&index=0&id=1b28c4ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b28c4ff",
  null
  
)

export default component.exports